import { IconProps } from "@/src/sb/business-layer/types"

const GlobeV2 = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8359 1.75C8.07045 1.75 2.58594 7.23451 2.58594 14C2.58594 20.7655 8.07045 26.25 14.8359 26.25C21.6014 26.25 27.0859 20.7655 27.0859 14C27.0782 7.23771 21.5982 1.75772 14.8359 1.75ZM4.33594 14C4.33777 11.0188 5.61095 8.17998 7.83594 6.19587V7.875C7.83594 8.8415 8.61944 9.625 9.58594 9.625H12.5452C13.2085 9.62531 13.8149 9.25059 14.1114 8.65725L14.5008 7.875H16.5859V11.375H12.4166C12.1454 11.3749 11.8779 11.4378 11.6352 11.5587L8.80281 12.9762C8.21066 13.2726 7.83646 13.8777 7.83594 14.5399V17.7817C7.83589 18.4973 8.27147 19.1408 8.93581 19.4066L12.3037 20.7541L12.8969 24.3119C7.93799 23.3751 4.34443 19.0466 4.33594 14ZM14.7012 24.493L13.8682 19.495L9.58594 17.7826V14.5407L12.4174 13.125H18.3359V6.125H13.4202L12.5452 7.875H9.58594V4.92013C12.2831 3.35005 15.5404 3.06595 18.4687 4.14535C21.397 5.22476 23.6906 7.55498 24.7234 10.5H20.0859V14L20.8927 17.3364L19.2109 19.8608V23.5331C17.84 24.1689 16.3471 24.4988 14.8359 24.5C14.7904 24.5 14.7467 24.4939 14.7012 24.493ZM20.9609 22.5111V20.3901L22.3487 18.3076C22.6223 17.8972 22.7102 17.3906 22.5911 16.912L21.8359 13.8924V12.25H25.1784C25.8767 16.1983 24.234 20.1951 20.9609 22.5111Z"
      fill="currentColor"
    />
  </svg>
)

export default GlobeV2
